import { Action } from '@ngrx/store';
import { TableState } from '@model';

export enum ManagersTableActionTypes {
  ManagerUsersPageChange = '[ManagersTable] Users Table Changed',
  ManagerInvitationsPageChange = '[ManagersTable] Invitations Table Changed',
  ManagersTableStateReset = '[ManagersTable] State reset',
  ManagerCustomerUsersPageChange = '[ManagersTable] Customer Users Table Changed',
  ManagerCustomersPageChange = '[ManagersTable] Customers Table Changed',
  ManagerUserCustomersPageChange = '[ManagersTable] User Customers Table Changed'
}

export class ManagerUsersPageChange implements Action {
  readonly type = ManagersTableActionTypes.ManagerUsersPageChange;
  constructor(public payload: TableState) {}
}

export class ManagerInvitationsPageChange implements Action {
  readonly type = ManagersTableActionTypes.ManagerInvitationsPageChange;
  constructor(public payload: TableState) {}
}

export class ManagerCustomerUsersPageChange implements Action {
  readonly type = ManagersTableActionTypes.ManagerCustomerUsersPageChange;
  constructor(public payload: TableState) {}
}
export class ManagerCustomersPageChange implements Action {
  readonly type = ManagersTableActionTypes.ManagerCustomersPageChange;
  constructor(public payload: TableState) {}
}

export class ManagersTableStateReset implements Action {
  readonly type = ManagersTableActionTypes.ManagersTableStateReset;
  constructor() {}
}

export class ManagerUserCustomersPageChange implements Action {
  readonly type = ManagersTableActionTypes.ManagerUserCustomersPageChange;
  constructor(public payload: TableState) {}
}

export type ManagersTableActions =
  | ManagerUsersPageChange
  | ManagerInvitationsPageChange
  | ManagerCustomerUsersPageChange
  | ManagerCustomersPageChange
  | ManagerUserCustomersPageChange
  | ManagersTableStateReset;
